exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page {\n  width: 10rem;\n  height: 100%;\n  background: #F7F7F7;\n  min-height: 100vh;\n  /* overflow: scroll; */\n}", ""]);

// exports
